import { path } from 'ramda';
import { ReactNode } from 'react';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { Box } from '@bridebook/ui';
import BorderedContainer from '@bridebook/web/app-shared/components/supplier/sections/bordered-container/bordered-container';
import InfoRow from '@bridebook/web/app-shared/components/supplier/sections/info-row/info-row';
import { useMarketDefaultLocale } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market-default-locale';
import { applyFormatter, isDefined } from '@bridebook/web/app-shared/lib/supplier/formatters';
import msg, { MsgKey } from '@bridebook/web/app-shared/lib/supplier/msg';
import componentStyles from './info-block.style';

interface IProps {
  icon?: ReactNode;
  items: string[];
  supplier: ISupplier | undefined;
  customLabels?: Partial<Record<MsgKey, MsgKey>>;
}

const InfoBlock = ({ icon, items, supplier, customLabels }: IProps) => {
  const styles = componentStyles();
  const locale = useMarketDefaultLocale();
  return (
    <BorderedContainer>
      <Box style={styles.wrapper}>
        {icon && <Box style={styles.iconSection}>{icon}</Box>}
        <Box style={styles.infoSection}>
          {items.map((item) => {
            const itemPath = item === 'typeDetails.venue.type' ? 'typeDetails.venue' : item;
            const formattedValue = applyFormatter(
              itemPath,
              path(itemPath.split('.'))(supplier),
              locale,
            );
            const customLabel = customLabels?.[item as MsgKey];
            const label = customLabel || item;

            return isDefined(formattedValue) ? (
              <Box style={styles.infoWrap} key={`info-list-item-${label}`}>
                <InfoRow title={msg[label as MsgKey]?.()} amount={formattedValue} />
              </Box>
            ) : null;
          })}
        </Box>
      </Box>
    </BorderedContainer>
  );
};

export default InfoBlock;
